angular.module("receipt.and.adjustment.templates", ["main/src/daily-entry/receipt-and-adjustment-daily-entry.html", "main/src/daily-entry/receipts-recap/receipts-recap.html", "main/src/entry-form/applied-amounts-popup.html", "main/src/entry-form/receipt-and-adjustment-entry-form.html", "main/src/receipt-and-adjustment-page.html", "main/src/review/receipt-and-adjustment-review.html", "main/src/user-preferences-setup/user-preferences-receipt-and-adjustment-entry-component.html", "server-check/index.html"]);

angular.module("main/src/daily-entry/receipt-and-adjustment-daily-entry.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("main/src/daily-entry/receipt-and-adjustment-daily-entry.html",
    "<div class=\"container-fluid no-left-padding view-container\">\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-md-12\">\n" +
    "            <div class=\"row\">\n" +
    "                <div class=\"col-md-12\">\n" +
    "                    <h1 class=\"no-top-margin\" id=\"titleText\">{{vm.dailyEntryHeaderLabel()}}</h1>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <bmp-view-mode-tabset bmp-view-mode-tabset-tabs=\"vm.tabs\" bmp-view-mode-tabset-orientation=\"top\">\n" +
    "                <div class=\"row\">\n" +
    "                    <receipt-and-adjustment-entry-form\n" +
    "                        receipt-and-adjustment-entry-form-on-load=\"vm.onEntryFormLoad(controller)\"\n" +
    "                        receipt-and-adjustment-entry-form-reload-new-id-state-change=\"vm.reloadNewIdStateChange(id)\"\n" +
    "                        receipt-and-adjustment-entry-form-allow-new=\"true\">\n" +
    "                    </receipt-and-adjustment-entry-form>\n" +
    "                    <div class=\"col-md-8\">\n" +
    "                        <h3 class=\"no-top-margin\">{{'Bluemoon.ReceiptAndAdjustment.DailyEntry.Summary' | translate}}</h3>\n" +
    "                        <div>\n" +
    "                            <receipts-recap\n" +
    "                                receipts-recap-type-options=\"vm.filteredTypeOptions()\"\n" +
    "                                receipts-recap-category-id=\"vm.categoryId\"\n" +
    "                                receipts-recap-edit-item=\"vm.editItem(id)\">\n" +
    "                            </receipts-recap>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </bmp-view-mode-tabset>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("main/src/daily-entry/receipts-recap/receipts-recap.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("main/src/daily-entry/receipts-recap/receipts-recap.html",
    "<div>\n" +
    "    <div class=\"bmp-summary-blocks\">\n" +
    "        <div class=\"row\">\n" +
    "            <div ng-class=\"vm.summaryBlockStyle()\">{{vm.summary.amountText}} <p>{{vm.summary.amount}}</p></div>\n" +
    "            <div ng-class=\"vm.summaryBlockStyle()\" ng-show=\"vm.summary.openAmountText\">{{vm.summary.openAmountText}} <p>{{vm.summary.openAmount}}</p></div>\n" +
    "            <div ng-class=\"vm.summaryBlockStyle()\" ng-show=\"vm.summary.openCreditsText\">{{vm.summary.openCreditsText}} <p>{{vm.summary.openCredits}}</p></div>\n" +
    "            <div ng-class=\"vm.summaryBlockStyle()\" ng-show=\"vm.summary.openDebitsText\">{{vm.summary.openDebitsText}} <p>{{vm.summary.openDebits}}</p></div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"well bm-well bmp-summary-blocks-detail\">\n" +
    "        <bmp-date-range-selector\n" +
    "            name=\"bm-receiptsRecap-dateRangeSelector\"\n" +
    "            bmp-date-range-selector-options=\"vm.dateRangeSelectorOptions\"\n" +
    "            bmp-date-range-selector-options-default=\"WEEK\"\n" +
    "            bmp-date-range-selector-changed=\"vm.onFilterChange(dateRangeId, startDate, endDate)\">\n" +
    "        </bmp-date-range-selector>\n" +
    "        <div bento-busy-loader=\"vm.loadPromise\" bento-busy-loader-size=\"small\">\n" +
    "            <wj-flex-grid control=\"vm.flexGrid\" items-source=\"vm.list.data\" class=\"bento-flex-grid\" headers-visibility=\"Column\"\n" +
    "                        selection-mode=\"None\" is-read-only=\"true\" items-source-changed=\"vm.itemsSourceChanged(s,e)\"  item-formatter=\"itemFormatter\" group-header-format=\"<b>{value}</b> ({count:n0} items)\">\n" +
    "                <wj-flex-grid-column header=\"\" binding=\"\" min-width=\"55\" width=\"55\" align=\"left\" is-read-only=\"true\">\n" +
    "                    <wj-flex-grid-cell-template cell-type=\"Cell\">\n" +
    "                        <span class=\"bento-icon-edit grid-action-icon\" ng-click=\"vm.editItem($item, $row)\" data-tooltip-placement=\"top\" data-tooltip-trigger=\"mouseenter\" data-uib-tooltip=\"{{ 'Bluemoon.Practice.Common.Actions.Edit' | translate }}\"  data-tooltip-append-to-body=\"true\">\n" +
    "                        </span>\n" +
    "                    </wj-flex-grid-cell-template>\n" +
    "                </wj-flex-grid-column>\n" +
    "                <wj-flex-grid-column width=\"2*\" header=\"{{ 'Core.Captions.AccountsReceivableOpen.EntryDate' | translate }}\" binding=\"entryDate\" visible=\"false\"></wj-flex-grid-column>\n" +
    "                <wj-flex-grid-column width=\"2*\" header=\"{{ 'Core.Captions.AccountsReceivableOpen.Client' | translate }}\" binding=\"client.name\"></wj-flex-grid-column>\n" +
    "                <wj-flex-grid-column width=\"2*\" header=\"{{ 'Core.Captions.AccountsReceivableOpen.BankAccount' | translate }}\" binding=\"bankAccount.code\"></wj-flex-grid-column>\n" +
    "                <wj-flex-grid-column width=\"2*\" header=\"{{ 'Core.Captions.AccountsReceivableOpen.AccountsReceivableType' | translate }}\" binding=\"accountsReceivableType.name\"></wj-flex-grid-column>\n" +
    "                <wj-flex-grid-column width=\"2*\" header=\"{{ 'Core.Captions.AccountsReceivableOpen.Reference' | translate }}\" binding=\"reference\"></wj-flex-grid-column>\n" +
    "                <wj-flex-grid-column width=\"2*\" header=\"{{ 'Core.Captions.AccountsReceivableOpen.Amount' | translate }}\" binding=\"normalAmount\" align=\"right\" aggregate=\"Sum\" format=\"C2\"></wj-flex-grid-column>\n" +
    "                <wj-flex-grid-column width=\"2*\" header=\"{{ 'Core.Captions.AccountsReceivableOpen.NormalOpenAmount' | translate }}\" binding=\"normalOpenAmount\" align=\"right\" aggregate=\"Sum\" format=\"C2\"></wj-flex-grid-column>\n" +
    "            </wj-flex-grid>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("main/src/entry-form/applied-amounts-popup.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("main/src/entry-form/applied-amounts-popup.html",
    "<button type=\"button\" class=\"close\" aria-hidden=\"true\" ng-click=\"cancel()\">\n" +
    "    <i class=\"bento-icon-close-x\"></i>\n" +
    "</button>\n" +
    "<div class=\"modal-header\">\n" +
    "    <span translate=\"Bluemoon.ReceiptAndAdjustment.AppliedAmountsPopup.Header\"></span>\n" +
    "</div>\n" +
    "<div class=\"bmp-summary-blocks\">\n" +
    "	<div class=\"row\">\n" +
    "		<div class=\"col-xs-6\">{{ ctrl.getAmountSummaryHeaderText() }}\n" +
    "			<p>{{receiptAmount | bmpNumber:'c2'}}</p>\n" +
    "		</div>\n" +
    "		<div class=\"col-xs-6\">{{'Core.Captions.AccountsReceivableOpen.NormalOpenAmount' | translate }}\n" +
    "			<p ng-style=\"ctrl.openAmountStyle\">{{ctrl.openAmountString | bmpNumber:'c2'}}</p>\n" +
    "		</div>\n" +
    "	</div>\n" +
    "</div>\n" +
    "<div class=\"bmp-summary-blocks-detail\">\n" +
    "<div bento-busy-loader=\"ctrl.showBusy\" bento-busy-loader-size=\"small\">\n" +
    "	<bmp-grid ng-if=\"ctrl.definition\" bmp-grid-definition=\"ctrl.definition\" bmp-grid-service=\"ctrl.service\"></bmp-grid>\n" +
    "</div>\n" +
    "</div>\n" +
    "<div class=\"row\">\n" +
    "    <div class=\"col-sm-12\">\n" +
    "		<div class=\"modal-footer\">\n" +
    "			<button class=\"btn btn-primary\" ng-click=\"save()\" translate>Bluemoon.Practice.Common.Actions.Save</button>\n" +
    "			<button class=\"btn btn-default\" ng-click=\"cancel()\" translate>Bluemoon.Practice.Common.Buttons.Cancel</button>\n" +
    "		</div>\n" +
    "	</div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("main/src/entry-form/receipt-and-adjustment-entry-form.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("main/src/entry-form/receipt-and-adjustment-entry-form.html",
    "<ng-form id=\"receiptAndAdjustmentEntryForm\" name=\"receiptAndAdjustmentEntryForm\">\n" +
    "    <div class=\"col-md-4\"\n" +
    "        bento-busy-loader=\"vm.detail.isLoadingData()\"\n" +
    "        bento-busy-loader-size=\"small\"\n" +
    "        bmp-detail-view-default-focus=\"vm.data\"\n" +
    "        bmp-detail-view-default-focus-focus-on-event=\"ReceiptAndAdjustmentEntryForm-AfterLoad\">\n" +
    "    <fieldset data-ng-disabled=\"vm.isFormReadOnly()\">\n" +
    "        <div class=\"row\">\n" +
    "            <!-- Control Date -->\n" +
    "            <!-- /* i18nextract */'Core.Captions.AccountsReceivable.ControlDate' -->\n" +
    "            <div ng-if=\"!vm.userPrefData.controlDateHide\"\n" +
    "                data-bmp-control-group=\"\"\n" +
    "                data-bmp-control-group-field-id=\"controlDate\"\n" +
    "                data-bmp-control-group-label=\"{{'Core.Captions.AccountsReceivable.ControlDate' | translate | bmRequiredMark}}\"\n" +
    "                data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'controlDate')\"\n" +
    "                class=\"col-md-6 col-sm-6 col-xs-12\">\n" +
    "                <bmp-bento-datepicker-wrapper id=\"receiptAndAdjustment.controlDate\"\n" +
    "                                            ng-model=\"vm.data.controlDate\"\n" +
    "                                            name=\"controlDate\"\n" +
    "                                            data-ng-required=\"true\"\n" +
    "                                            data-ng-disabled=\"vm.domain.isDisabledControlDate()\"\n" +
    "                                            data-ng-change=\"vm.controlDateChange()\"\n" +
    "                                            bmp-bento-datepicker-wrapper-tab-stop=\"!vm.userPrefData.controlDateSkip\">\n" +
    "                </bmp-bento-datepicker-wrapper>\n" +
    "            </div>\n" +
    "            <!-- Entry Date -->\n" +
    "            <!-- /* i18nextract */'Core.Captions.AccountsReceivable.EntryDate' -->\n" +
    "            <div ng-if=\"!vm.userPrefData.entryDateHide\"\n" +
    "                data-bmp-control-group=\"\"\n" +
    "                data-bmp-control-group-field-id=\"entryDate\"\n" +
    "                data-bmp-control-group-label=\"{{'Core.Captions.AccountsReceivable.EntryDate' | translate | bmRequiredMark}}\"\n" +
    "                data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'entryDate')\"\n" +
    "                class=\"col-md-6 col-sm-6 col-xs-12\">\n" +
    "                <bmp-bento-datepicker-wrapper id=\"receiptAndAdjustment.entryDate\"\n" +
    "                                            ng-model=\"vm.data.entryDate\"\n" +
    "                                            name=\"entryDate\"\n" +
    "                                            data-ng-required=\"true\"\n" +
    "                                            data-ng-disabled=\"vm.domain.isDisabledEntryDate()\"\n" +
    "                                            bmp-bento-datepicker-wrapper-tab-stop=\"!vm.userPrefData.entryDateSkip\">\n" +
    "                </bmp-bento-datepicker-wrapper>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"row\">\n" +
    "            <!-- Bank Account -->\n" +
    "            <div ng-if=\"!vm.userPrefData.bankAccountHide\"\n" +
    "                data-bmp-control-group=\"\"\n" +
    "                data-bmp-control-group-field-id=\"bankAccount\"\n" +
    "                data-bmp-control-group-label=\"{{'Core.Captions.AccountsReceivable.BankAccount' | translate}}\"\n" +
    "                data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'bankAccount')\"\n" +
    "                class=\"col-md-12 col-sm-12 col-xs-12\">\n" +
    "                <bmp-select-combo list=\"bankAccount\"\n" +
    "                                name=\"bankAccount\"\n" +
    "                                ng-model=\"vm.data.bankAccount\"\n" +
    "                                filter=\"vm.bankAccountFilter()\"\n" +
    "                                data-ng-disabled=\"vm.domain.isDisabledBankAccount()\"\n" +
    "                                data-bmp-tab-stop=\"!vm.userPrefData.bankAccountSkip\">\n" +
    "                </bmp-select-combo>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"row\">\n" +
    "            <!-- Client -->\n" +
    "            <!-- /* i18nextract */'Core.Captions.AccountsReceivable.Client' -->\n" +
    "            <div data-bmp-control-group=\"\"\n" +
    "                data-bmp-control-group-field-id=\"client\"\n" +
    "                data-bmp-control-group-label=\"{{'Core.Captions.AccountsReceivable.Client' | translate | bmRequiredMark}}\"\n" +
    "                data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'client')\"\n" +
    "                class=\"col-md-12 col-sm-12 col-xs-12\">\n" +
    "                <bmp-select-combo list=\"clients#notInactive\"\n" +
    "                                name=\"client\"\n" +
    "                                ng-model=\"vm.data.$client\"\n" +
    "                                required=\"true\"\n" +
    "                                data-ng-disabled=\"vm.domain.isDisabledClient()\"\n" +
    "                                aotf=\"vm.clientAotf\">\n" +
    "                </bmp-select-combo>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"row\">\n" +
    "            <!-- A/R Balance -->\n" +
    "            <div data-bmp-control-group=\"\"\n" +
    "                data-bmp-control-group-field-id=\"arBalance\"\n" +
    "                data-bmp-control-group-label=\"{{'Bluemoon.ReceiptAndAdjustment.DailyEntry.ARBalance' | translate}}\"\n" +
    "                class=\"col-md-12 col-sm-12 col-xs-12\">\n" +
    "                <input autocomplete=\"off\" name=\"arBalance\"\n" +
    "                    type=\"text\"\n" +
    "                    readonly class=\"form-control input-lg\"\n" +
    "                    data-ng-model=\"vm.data.$arBalance\"\n" +
    "                    data-bmp-big-number=\"'c2'\"/>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"row\">\n" +
    "            <!-- Type -->\n" +
    "            <!-- /* i18nextract */'Core.Captions.AccountsReceivable.AccountsReceivableType' -->\n" +
    "            <div data-bmp-control-group=\"\"\n" +
    "                data-bmp-control-group-field-id=\"accountsReceivableType\"\n" +
    "                data-bmp-control-group-label=\"{{'Core.Captions.AccountsReceivable.AccountsReceivableType' | translate | bmRequiredMark}}\"\n" +
    "                data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'accountsReceivableType')\"\n" +
    "                class=\"col-md-12 col-sm-12 col-xs-12\">\n" +
    "                <span data-bento-select>\n" +
    "                    <select id=\"accountsReceivableType\"\n" +
    "                            name=\"accountsReceivableType\"\n" +
    "                            class=\"form-control\"\n" +
    "                            data-ng-model=\"vm.data.$accountsReceivableType\"\n" +
    "                            data-ng-options=\"option as option.name for option in vm.filteredTypeOptions() track by option.id\"\n" +
    "                            data-ng-required=\"true\"\n" +
    "                            data-ng-disabled=\"vm.isFormReadOnly() || vm.domain.isDisabledAccountsReceivableType()\">\n" +
    "                    </select>\n" +
    "                </span>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"row\">\n" +
    "            <!-- Reference -->\n" +
    "            <div ng-if=\"!vm.userPrefData.referenceHide\"\n" +
    "                data-bmp-control-group=\"\"\n" +
    "                data-bmp-control-group-field-id=\"reference\"\n" +
    "                data-bmp-control-group-label=\"{{'Core.Captions.AccountsReceivable.Reference' | translate }}\"\n" +
    "                data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'reference')\"\n" +
    "                class=\"col-md-12 col-sm-12 col-xs-12\">\n" +
    "                <input autocomplete=\"off\" name=\"reference\"\n" +
    "                    type=\"text\"\n" +
    "                    class=\"form-control input-lg\"\n" +
    "                    data-ng-model=\"vm.data.reference\"\n" +
    "                    data-bmp-tab-stop=\"!vm.userPrefData.referenceSkip\" />\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"row\">\n" +
    "            <!-- Amount -->\n" +
    "            <!-- /* i18nextract */'Core.Captions.AccountsReceivable.Amount' -->\n" +
    "            <div data-bmp-control-group=\"\"\n" +
    "                data-bmp-control-group-field-id=\"amount\"\n" +
    "                data-bmp-control-group-label=\"{{'Core.Captions.AccountsReceivable.Amount' | translate | bmRequiredMark}}\"\n" +
    "                data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'amount')\"\n" +
    "                class=\"col-md-12 col-sm-12 col-xs-12\">\n" +
    "                <input autocomplete=\"off\" id=\"amount\"\n" +
    "                    name=\"amount\"\n" +
    "                    type=\"text\"\n" +
    "                    class=\"form-control input-lg\"\n" +
    "                    data-ng-model=\"vm.data.$normalAmount\"\n" +
    "                    data-ng-model-options=\"{updateOn: 'blur'}\"\n" +
    "                    data-bmp-clear-value=\"0\"\n" +
    "                    data-bmp-big-number=\"'c2'\"\n" +
    "                    data-bmp-big-number-range-validator\n" +
    "                    bm-format-on-blur=\"\"\n" +
    "                    min=\"0\"\n" +
    "                    max=\"99999.99\"\n" +
    "                    data-ng-required=\"true\"\n" +
    "                    data-ng-disabled=\"vm.domain.isDisabledAmount()\"\n" +
    "                    data-bmp-control-group-field=\"Core.Captions.AccountsReceivable.Amount\" />\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"row\">\n" +
    "            <!-- Open Amount -->\n" +
    "            <div data-bmp-control-group=\"\"\n" +
    "                data-bmp-control-group-field-id=\"amount\"\n" +
    "                data-bmp-control-group-label=\"{{'Core.Captions.AccountsReceivableOpen.NormalOpenAmount' | translate }}\"\n" +
    "                data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'amount')\"\n" +
    "                class=\"col-md-12 col-sm-12 col-xs-12\">\n" +
    "                <input autocomplete=\"off\" name=\"$normalOpenAmount\"\n" +
    "                    type=\"text\"\n" +
    "                    readonly class=\"form-control input-lg\"\n" +
    "                    data-ng-model=\"vm.data.$normalOpenAmount\"\n" +
    "                    data-bmp-big-number=\"'c2'\"\n" +
    "                    data-bmp-control-group-field=\"Core.Captions.AccountsReceivableOpen.NormalOpenAmount\" />\n" +
    "                <div>\n" +
    "                    <!-- Apply/View Applied Amounts -->\n" +
    "                    <a ng-show=\"vm.applyAmountsLinkVisible()\" ng-click=\"vm.showAppliedAmountsPopup()\" >{{vm.applyAmountsLinkText()}}</a>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"row\">\n" +
    "            <!-- Comment -->\n" +
    "            <div ng-if=\"!vm.userPrefData.commentHide\"\n" +
    "                data-bmp-control-group=\"\"\n" +
    "                data-bmp-control-group-field-id=\"notes\"\n" +
    "                data-bmp-control-group-label=\"{{'Core.Captions.AccountsReceivable.Notes' | translate }}\"\n" +
    "                data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'notes')\"\n" +
    "                class=\"col-md-12 col-sm-12 col-xs-12\">\n" +
    "                <bmp-standard-text-input name=\"notes\"\n" +
    "                    label=\"{{'Core.Captions.AccountsReceivable.Notes' | translate }}\"\n" +
    "                    ng-model=\"vm.data.notes\"\n" +
    "                    tab-stop=\"!vm.userPrefData.commentSkip\" />\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </fieldset>\n" +
    "    <div style=\"padding-bottom: 12px\">{{'Bluemoon.Practice.Common.Grid.RequiredItems' | translate}}</div>\n" +
    "    <button type=\"button\" data-fef-tab-stop=\"true\" id=\"receiptAndAdjustmentDailyEntryForm.save\"\n" +
    "            class=\"btn btn-primary\"\n" +
    "            data-ng-click=\"vm.save();\"\n" +
    "            data-ng-disabled=\"!vm.detail.canSave\"\n" +
    "            data-qe-id=\"bm-receiptAndAdjustmentDailyEntryForm-{{vm.categoryId | lowercase}}-save-button\"\n" +
    "            translate=\"Bluemoon.Practice.Common.Actions.Save\"></button>\n" +
    "    <button type=\"button\" data-fef-tab-stop=\"true\" id=\"receiptAndAdjustmentDailyEntryForm.cancel\"\n" +
    "            class=\"btn btn-default\"\n" +
    "            data-ng-click=\"vm.cancelEdit();\"\n" +
    "            data-ng-disabled=\"vm.detail.isNew && !vm.detail.canSave\"\n" +
    "            data-qe-id=\"bm-receiptAndAdjustmentDailyEntryForm-{{vm.categoryId | lowercase}}-cancel-button\"\n" +
    "            translate=\"Bluemoon.Practice.Common.Actions.Cancel\"></button>\n" +
    "    <button type=\"button\" data-fef-tab-stop=\"true\" id=\"receiptAndAdjustmentDailyEntryForm.delete\"\n" +
    "            class=\"btn btn-default\"\n" +
    "            data-ng-click=\"vm.deleteEntry();\"\n" +
    "            data-ng-hide=\"vm.detail.isNew\"\n" +
    "            translate=\"Bluemoon.Practice.Common.Actions.Delete\"></button>\n" +
    "</div>\n" +
    "</ng-form>\n" +
    "<script type=\"text/ng-template\" id=\"editConfirmationPrompt\">\n" +
    "    <div class=\"modal-body modal-confirm-body\">\n" +
    "        <i class=\"glyphicons warning_sign modal-confirm-icon\"></i>\n" +
    "        <span class=\"modal-confirm-message\" translate-value-client=\"{{vm.data.client.name}}\"\n" +
    "                translate=\"Bluemoon.ReceiptAndAdjustment.Recap.EditConfirmationDialog.Body\">\n" +
    "        </span>\n" +
    "    </div>\n" +
    "    <div class=\"modal-footer\">\n" +
    "        <button class=\"btn btn-primary\" ng-click=\"yes()\" translate>Bluemoon.Practice.Common.Actions.Yes</button>\n" +
    "        <button class=\"btn btn-default\" ng-click=\"no()\" translate>Bluemoon.Practice.Common.Actions.No</button>\n" +
    "        <button class=\"btn btn-default\" ng-click=\"cancel()\" translate>Bluemoon.Practice.Common.Buttons.Cancel</button>\n" +
    "    </div>\n" +
    "</script>\n" +
    "");
}]);

angular.module("main/src/receipt-and-adjustment-page.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("main/src/receipt-and-adjustment-page.html",
    "<div class=\"container-fluid no-padding-l\">\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-md-12\">\n" +
    "            <bmp-routable-tabset bmp-routable-tabset-tabs=\"vm.tabs\">\n" +
    "                <div ui-view class=\"enter-item-animation\"></div>\n" +
    "            </bmp-routable-tabset>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("main/src/review/receipt-and-adjustment-review.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("main/src/review/receipt-and-adjustment-review.html",
    "<div class=\"container-fluid no-left-padding view-container no-bottom-margin\">\n" +
    "    <h1 class=\"no-top-margin\">{{'Bluemoon.ReceiptAndAdjustment.ReviewReceiptsAndAdjustments' | translate}}</h1>\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-md-12\">\n" +
    "            <div class=\"setup-list-grid-view\">\n" +
    "                <div class=\"row\">\n" +
    "                    <bmp-slideout-panel bmp-slideout-panel-show=\"vm.showEntryForm()\">\n" +
    "                        <receipt-and-adjustment-entry-form\n" +
    "                            receipt-and-adjustment-entry-form-on-load=\"vm.onEntryFormLoad(controller)\"\n" +
    "                            receipt-and-adjustment-entry-form-reload-new-id-state-change=\"vm.reloadNewIdStateChange(id)\">\n" +
    "                        </receipt-and-adjustment-entry-form>\n" +
    "                    </bmp-slideout-panel>\n" +
    "                    <div ng-class=\"vm.isGridSmaller() ? 'col-md-8': 'col-md-12'\">\n" +
    "                        <div class=\"row filters\">\n" +
    "                            <!--LEFT SIDE GRID FILTERS-->\n" +
    "                            <div class=\"col-xs-12 col-md-8\">\n" +
    "                                <bmp-date-range-selector name=\"bm-receiptAndAdjustment-dateRangeSelector\" bmp-date-range-selector-options=\"vm.dateRangeSelectorOptions\"\n" +
    "                                bmp-date-range-selector-options-default=\"WEEK\" bmp-date-range-selector-changed=\"vm.onFilterChange({dateRangeId: dateRangeId, startDate: startDate, endDate: endDate})\">\n" +
    "                                </bmp-date-range-selector>\n" +
    "                            </div>\n" +
    "\n" +
    "                            <!--RIGHT SIDE GRID FILTERS-->\n" +
    "                            <div class=\"col-xs-12 col-md-4 bm-receiptAndAdjustment-posted-and-approved\">\n" +
    "                                <bmp-posted-and-approved-filters ng-if=\"vm.isApproveEnabled\"\n" +
    "                                                                    posted=\"vm.postedFilter\"\n" +
    "                                                                    approved=\"vm.approvedFilter\"\n" +
    "                                                                    on-changed=\"vm.onFilterChange()\"\n" +
    "                                                                    user-settings-key=\"vm.userSettingsKey\">\n" +
    "                                </bmp-posted-and-approved-filters>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                        <bmp-grid data-bmp-grid-definition=\"vm.definition\" data-bmp-grid-service=\"vm.provider\"></bmp-grid>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("main/src/user-preferences-setup/user-preferences-receipt-and-adjustment-entry-component.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("main/src/user-preferences-setup/user-preferences-receipt-and-adjustment-entry-component.html",
    "<h3 data-ng-show=\"$ctrl.detail.isLoadingData()\">{{$ctrl.detail.busyText}}</h3>\n" +
    "<ng-form id=\"userPreferencesTimeAndBillingReceiptAndAdjustmentEntryForm\" name=\"userPreferencesTimeAndBillingReceiptAndAdjustmentEntryForm\" data-ng-hide=\"$ctrl.detail.isLoadingData()\" autocomplete=\"off\">\n" +
    "    <h3>{{'Bluemoon.ReceiptAndAdjustment.UserPreferencesSetup.Section.FieldDefaultsAndSettings' | translate}}</h3>\n" +
    "    <div class=\"row\">\n" +
    "        <!-- Default Control Date -->\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "            data-bmp-control-group-field-id=\"defaultControlDate\"\n" +
    "            data-bmp-control-group-label=\"{{'Core.Captions.ContactUserPrefRAEntry.DefaultControlDate' | translate}}\"\n" +
    "            data-bmp-control-group-error=\"$ctrl.detail.errorFor($ctrl.data, 'defaultControlDate')\"\n" +
    "            class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "            <bmp-enum-combo enum=\"user-preference-default-control-date\"\n" +
    "                        name=\"defaultControlDate\"\n" +
    "                        data-qe-id=\"defaultControlDate\"\n" +
    "                        ng-model=\"$ctrl.data.defaultControlDate\"\n" +
    "                        required=\"true\"></bmp-enum-combo>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"row\">\n" +
    "        <!-- Default Date -->\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "            data-bmp-control-group-field-id=\"defaultEntryDate\"\n" +
    "            data-bmp-control-group-label=\"{{'Core.Captions.ContactUserPrefRAEntry.DefaultEntryDate' | translate}}\"\n" +
    "            data-bmp-control-group-error=\"$ctrl.detail.errorFor($ctrl.data, 'defaultEntryDate')\"\n" +
    "            class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "            <bmp-enum-combo enum=\"user-preference-r-a-default-entry-date\"\n" +
    "                        name=\"defaultEntryDate\"\n" +
    "                        data-qe-id=\"defaultEntryDate\"\n" +
    "                        ng-model=\"$ctrl.data.defaultEntryDate\"\n" +
    "                        required=\"true\"></bmp-enum-combo>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"row\">\n" +
    "        <!-- Hide and Skip Fields -->\n" +
    "        <div class=\"col-md-10 col-sm-10 col-xs-12 form-group bmp-wijmo-table-container\">\n" +
    "            <table class=\"bm-receiptAndAdjustment-up-hide-skip-table bmp-user-preferences-table bento-flex-grid wj-content\">\n" +
    "                <tr class=\"wj-colheaders\">\n" +
    "                    <th scope=\"col\" class=\"wj-header wj-cell\">{{'Bluemoon.ReceiptAndAdjustment.UserPreferencesSetup.HideSkipTable.Header.FieldName' | translate}}</th>\n" +
    "                    <th scope=\"col\" class=\"wj-header wj-cell\">{{'Bluemoon.ReceiptAndAdjustment.UserPreferencesSetup.HideSkipTable.Header.HideField' | translate}}</th>\n" +
    "                    <th scope=\"col\" class=\"wj-header wj-cell\">{{'Bluemoon.ReceiptAndAdjustment.UserPreferencesSetup.HideSkipTable.Header.SkipWhenTabbing' | translate}}</th>\n" +
    "                </tr>\n" +
    "                <tr>\n" +
    "                    <th scope=\"row\" class=\"wj-cell\">{{'Bluemoon.ReceiptAndAdjustment.UserPreferencesSetup.HideSkipTable.Field.DefaultControlDate' | translate}}</th>\n" +
    "                    <td class=\"wj-cell\">\n" +
    "                        <input id=\"controlDateHide\" name=\"controlDateHide\" data-qe-id=\"controlDateHide\" type=\"checkbox\" ng-model=\"$ctrl.data.$controlDateHide\" />\n" +
    "                        <label for=\"controlDateHide\" class=\"sr-only\">{{'Core.Captions.ContactUserPrefRAEntry.ControlDateHide' | translate}}</label>\n" +
    "                    </td>\n" +
    "                    <td class=\"wj-cell\">\n" +
    "                        <input id=\"controlDateSkip\" name=\"controlDateSkip\" data-qe-id=\"controlDateSkip\" type=\"checkbox\" ng-model=\"$ctrl.data.$controlDateSkip\" />\n" +
    "                        <label for=\"controlDateSkip\" class=\"sr-only\">{{'Core.Captions.ContactUserPrefRAEntry.ControlDateSkip' | translate}}</label>\n" +
    "                    </td>\n" +
    "                </tr>\n" +
    "                <tr>\n" +
    "                    <th scope=\"row\" class=\"wj-cell\">{{'Bluemoon.ReceiptAndAdjustment.UserPreferencesSetup.HideSkipTable.Field.Date' | translate}}</th>\n" +
    "                    <td class=\"wj-cell\">\n" +
    "                        <input id=\"entryDateHide\" name=\"entryDateHide\" data-qe-id=\"entryDateHide\" type=\"checkbox\" ng-model=\"$ctrl.data.$entryDateHide\" />\n" +
    "                        <label for=\"entryDateHide\" class=\"sr-only\">{{'Core.Captions.ContactUserPrefRAEntry.EntryDateHide' | translate}}</label>\n" +
    "                    </td>\n" +
    "                    <td class=\"wj-cell\">\n" +
    "                        <input id=\"entryDateSkip\" name=\"entryDateSkip\" data-qe-id=\"entryDateSkip\" type=\"checkbox\" ng-model=\"$ctrl.data.$entryDateSkip\" />\n" +
    "                        <label for=\"entryDateSkip\" class=\"sr-only\">{{'Core.Captions.ContactUserPrefRAEntry.EntryDateSkip' | translate}}</label>\n" +
    "                    </td>\n" +
    "                </tr>\n" +
    "\n" +
    "                <tr>\n" +
    "                    <th scope=\"row\" class=\"wj-cell\">{{'Bluemoon.ReceiptAndAdjustment.UserPreferencesSetup.HideSkipTable.Field.BankAccount' | translate}}</th>\n" +
    "                    <td class=\"wj-cell\">\n" +
    "                        <input id=\"bankAccountHide\" name=\"bankAccountHide\" data-qe-id=\"bankAccountHide\" type=\"checkbox\" ng-model=\"$ctrl.data.$bankAccountHide\" />\n" +
    "                        <label for=\"bankAccountHide\" class=\"sr-only\">{{'Core.Captions.ContactUserPrefRAEntry.BankAccountHide' | translate}}</label>\n" +
    "                    </td>\n" +
    "                    <td class=\"wj-cell\">\n" +
    "                        <input id=\"bankAccountSkip\" name=\"bankAccountSkip\" data-qe-id=\"bankAccountSkip\" type=\"checkbox\" ng-model=\"$ctrl.data.$bankAccountSkip\" />\n" +
    "                        <label for=\"bankAccountSkip\" class=\"sr-only\">{{'Core.Captions.ContactUserPrefRAEntry.BankAccountSkip' | translate}}</label>\n" +
    "                    </td>\n" +
    "                </tr>\n" +
    "                <tr>\n" +
    "                    <th scope=\"row\" class=\"wj-cell\">{{'Bluemoon.ReceiptAndAdjustment.UserPreferencesSetup.HideSkipTable.Field.Reference' | translate}}</th>\n" +
    "                    <td class=\"wj-cell\">\n" +
    "                        <input id=\"referenceHide\" name=\"referenceHide\" data-qe-id=\"referenceHide\" type=\"checkbox\" ng-model=\"$ctrl.data.$referenceHide\" />\n" +
    "                        <label for=\"referenceHide\" class=\"sr-only\">{{'Core.Captions.ContactUserPrefRAEntry.ReferenceHide' | translate}}</label>\n" +
    "                    </td>\n" +
    "                    <td class=\"wj-cell\">\n" +
    "                        <input id=\"referenceSkip\" name=\"referenceSkip\" data-qe-id=\"referenceSkip\" type=\"checkbox\" ng-model=\"$ctrl.data.$referenceSkip\" />\n" +
    "                        <label for=\"referenceSkip\" class=\"sr-only\">{{'Core.Captions.ContactUserPrefRAEntry.ReferenceSkip' | translate}}</label>\n" +
    "                    </td>\n" +
    "                </tr>\n" +
    "                <tr>\n" +
    "                    <th scope=\"row\" class=\"wj-cell\">{{'Bluemoon.ReceiptAndAdjustment.UserPreferencesSetup.HideSkipTable.Field.Comment' | translate}}</th>\n" +
    "                    <td class=\"wj-cell\">\n" +
    "                        <input id=\"commentHide\" name=\"commentHide\" data-qe-id=\"commentHide\" type=\"checkbox\" ng-model=\"$ctrl.data.$commentHide\" />\n" +
    "                        <label for=\"commentHide\" class=\"sr-only\">{{'Core.Captions.ContactUserPrefRAEntry.CommentHide' | translate}}</label>\n" +
    "                    </td>\n" +
    "                    <td class=\"wj-cell\">\n" +
    "                        <input id=\"commentSkip\" name=\"commentSkip\" data-qe-id=\"commentSkip\" type=\"checkbox\" ng-model=\"$ctrl.data.$commentSkip\" />\n" +
    "                        <label for=\"commentSkip\" class=\"sr-only\">{{'Core.Captions.ContactUserPrefRAEntry.CommentSkip' | translate}}</label>\n" +
    "                    </td>\n" +
    "                </tr>\n" +
    "            </table>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-md-4 col-sm-4 col-xs-6\">\n" +
    "            <input id=\"autoApplyToOldestFirst\" name=\"autoApplyToOldestFirst\" data-qe-id=\"autoApplyToOldestFirst\" type=\"checkbox\" ng-model=\"$ctrl.data.autoApplyToOldestFirst\" />\n" +
    "            <label for=\"autoApplyToOldestFirst\">{{'Core.Captions.ContactUserPrefRAEntry.AutoApplyToOldestFirst' | translate}}</label>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-md-4 col-sm-4 col-xs-6\">\n" +
    "            <input id=\"autoDisplayAppliedAmounts\" name=\"autoDisplayAppliedAmounts\" data-qe-id=\"autoDisplayAppliedAmounts\" type=\"checkbox\" ng-model=\"$ctrl.data.autoDisplayAppliedAmounts\" />\n" +
    "            <label for=\"autoDisplayAppliedAmounts\">{{'Core.Captions.ContactUserPrefRAEntry.AutoDisplayAppliedAmounts' | translate}}</label>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</ng-form>");
}]);

angular.module("server-check/index.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("server-check/index.html",
    "<Status xmlns:i=\"http://www.w3.org/2001/XMLSchema-instance\" xmlns=\"http://schemas.datacontract.org/2004/07/Cobalt.BlueMoonClients.Web.Models\">\n" +
    "    <Resources>\n" +
    "        <Result>OK</Result>\n" +
    "    </Resources>\n" +
    "</Status>\n" +
    "");
}]);
